import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Include this component to scroll to the top of the page when the route changes.
 */
const ScrollToTop = () => {
	const { pathname } = useLocation()

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
